import PropTypes from 'prop-types';
import { LinkContainer } from 'react-router-bootstrap/lib';
import { Icon } from 'semantic-ui-react';
import React, { memo } from 'react';
import { hasAnyOfRole } from './menuBuilder';
import './DashboardSidebar.scss';

const DashboardSublist = memo(({ subItems, user, subMenuName }) => (
  <div className="sidebar-list-item sidebar-subList">
    <p>
      <Icon name="unordered list" className="sidebar-list-icon" />
      {subMenuName}
    </p>
    {subItems.map(item => {
      const url = item.getUrl(user);
      // Filter if these should be shown to the current user
      if (hasAnyOfRole(user)(item))
        return (
          <LinkContainer to={url} key={url}>
            <div className="sidebar-subList-item">
              <p>{item.name}</p>
            </div>
          </LinkContainer>
        );
      return null;
    })}
  </div>
));

DashboardSublist.propTypes = {
  user: PropTypes.object,
  subItems: PropTypes.array,
  subMenuName: PropTypes.string,
};

export default DashboardSublist;
